import axios from 'axios';

const api=axios.create({
    baseURL:process.env.REACT_APP_API_URL + "/api",
});
api.interceptors.request.use((config)=>{
    const token=localStorage.getItem("access_token");
    if(token){
        config.headers.Authorization=`Bearer ${token}`;
    }
    return config;
});
export default api;

console.log("API URL:", process.env.REACT_APP_API_URL);